/**
 * 車両台帳ページ用のスクリプト
 */
 var vehicle_treemultiselect = null;

if (is_route('vehicle.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        vehicle_event_set();
        vehicle_setting_event_set();
        // vehicle_batch_transfer_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.vehicle_event_set = function () {

    // ボタンクリック時のバブリングを禁止
    $(document).on('click', '.certificate_file_link', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });

    /*---- 詳細表示時 ----*/

    // 詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['id']);
    });

    // 前へ・次へ
    $(document).on('click', '.modal-vehicle-prev, .modal-vehicle-next', function () {
        let datas = $('#search-form').serializeArray();
        datas.push({'name': 'id', 'value': $(this).data('id')});
        let action = $(this).data('action');
        let modalId = $(this).data('modal_id');
        _modal.update(modalId, action, datas);
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id', 'type']);
    });

    /*---- 所属一括変更表示時 ----*/

    // 所属一括変更表示時
    $(document).on('click', '#search-form-action_batch_transfer', function () {
        _modal.create(this, 'batch-transfer-modal', ['id', 'type'], false, function() {
            vehicle_treemultiselect = initialize_treemultiselect();
            vehicle_batch_transfer_event_set();
        });
    });

    /*---- 履歴表示時 ----*/

    // 履歴表示時
    $(document).on('click', '[data-history-modal]', function () {
        _modal.create(this, 'history-modal', ['id', 'page']);
        return false;
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
            $('[data-detail-modal=vehicle-detail-modal][data-id=' + results.vehicle.id + ']').trigger('click');
        }, function() {
            vehicle_set_steper_error();
        });
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#vehicle-all-delete', function () {
        $(".vehicle-delete").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.vehicle-delete', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#vehicle-all-delete, .vehicle-delete', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#vehicle-multi-delete-button').prop('disabled', ($('.vehicle-delete:checked').length == 0));
    });

    /*---- 除確認時 ----*/

    // 一括削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        if ($(this).data('id') == null) {
            $('.vehicle-delete[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        if (ids.length > 0) {
            _modal.create_with_data(this, 'confirm-modal', {'ids': ids});
        }
    });

    /*---- 削除処理 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            _modal.hide('#vehicle-detail-modal');
        });
    });

    // /*---- CSVダウンロード時 ----*/

    // // CSVダウンロード時
    // $(document).on('click', '#search-form-action_download', function () {
    //     // アクションの取得
    //     let action = extend_url_query($(this).data('action'));
    //     // 検索フォームを配列化
    //     let datas = $('#search-form').serializeArray();
    //     // ポスト送信を実行
    //     post(action, datas);
    // });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $('#vehicle-csv-setting-modal-csv-submit-message').addClass('display-none');
        $('#vehicle-csv-setting-modal-csv-submit-message').empty();
        $('#vehicle-csv-setting-modal-csv-error').addClass('display-none');
        $('#vehicle-csv-setting-modal-csv-error').empty();
        $('#vehicle-csv-setting-modal-csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', '#vehicle-csv-setting-modal-csv', function () {
        let modalId = '#vehicle-csv-setting-modal';
        let formId = '#vehicle-csv-setting-modal-form';
        let action = $(formId).data('confirm-action');
        let datas = new FormData($(formId).get(0));
        $(modalId + '-csv-error').addClass('display-none');
        $(modalId + '-csv-error').empty();
        $(modalId + '-csv-submit-message').addClass('display-none');
        $(modalId + '-csv-submit-message').empty();
        $("[data-csv-save-modal]").prop("disabled", true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(modalId + '-csv-submit-message').removeClass('display-none');
            $(modalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown){
            $('#vehicle-csv-setting-modal-csv').val('');
            _error.omitted(xhr, status, errorThrown, false);
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(modalId + '-csv-error').removeClass('display-none');
                $(modalId + '-csv-error').append($('<li></li>').text(message));
            });
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let modalId = '#vehicle-csv-setting-modal';
        let formId = '#vehicle-csv-setting-modal-form';
        let action = $(formId).attr('action');
        let datas = new FormData($(formId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(modalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });

    $(document).on('click', '.transfered .btn-group', function (event) {
        event.preventDefault();
    });
}
/**
 * 設定モーダル表示時のイベント設定
 * @uses ダッシュボードからモーダル表示する際にも呼び出される
 */
window.vehicle_setting_event_set = function () {

    /*---- ステップボタンクリック時（新規登録時） ----*/

    // 前へ
    $(document).on('click', '[data-prev-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let prevPart = $(this).data('prev-step');
        let prevPartTrigger = create_id(prevPart + '-trigger');
        let prevPartSubmit = create_id(prevPart + '-submit');
        $(currentPartSubmit).addClass('display-none');
        $(prevPartSubmit).removeClass('display-none');
        bs_step_trigger(prevPartTrigger);
    });

    // 次へ
    $(document).on('click', '[data-next-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let nextPart = $(this).data('next-step');
        let nextPartTrigger = create_id(nextPart + '-trigger');
        let nextPartSubmit = create_id(nextPart + '-submit');
        // ModalとPartセレクターの指定
        let modalId = '#vehicle-setting-modal';
        let formId = '#vehicle-setting-modal-form';
        let action = $(formId).data('confirm-action');
        // 確認対象のパートをパラメータにセット
        $('#vehicle-setting-modal-confirm_step').val($(this).data('confirm-step'));
        // 送信前にエラーをリセット
        _error.reset()
        vehicle_set_steper_error(false);
        // 確認用のpost送信
        _ajax.confirm_submit(formId, action, function (results) {
            $(currentPartSubmit).addClass('display-none');
            $(nextPartSubmit).removeClass('display-none');
            bs_step_trigger(nextPartTrigger);
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown, false);
            // ステップエラーを表示
            vehicle_set_steper_error();
        });
    });
}
// ステッパーへのエラー表示処理
window.vehicle_set_steper_error = function (showError = true) {
    if (showError) {
        $('#base-part-trigger').toggleClass('error', ($('#base-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#certificate-part-trigger').toggleClass('error', ($('#certificate-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#insurance-part-trigger').toggleClass('error', ($('#insurance-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#other-part-trigger').toggleClass('error', ($('#other-part').find('.invalid-feedback:not(.copy)').length > 0));
    } else {
        $('#base-part-trigger').removeClass('error');
        $('#certificate-part-trigger').removeClass('error');
        $('#insurance-part-trigger').removeClass('error');
        $('#other-part-trigger').removeClass('error');
    }
}

/**
 * 所属一括変更モーダル表示時のイベント設定
 */
window.vehicle_batch_transfer_event_set = function () {

    /*---- 初期処理 ----*/

    let holdingId = $('#vehicle-batch-transfer-modal-holding_id').val();
    if (holdingId.length > 0) {
        setTreeMultiSelect('#vehicle-batch-transfer-modal-holding_id', 'select.vehicles-select', {'type': 'transfer', 'holding_id': holdingId});
    }

    /*---- グループ変更時 ----*/
    $(document).off('change', '#vehicle-batch-transfer-modal select.holding-select');
    $(document).on('change', '#vehicle-batch-transfer-modal select.holding-select', function () {
     let holdingId = $(this).val();
     let select = $(this).parents('form').find('select.vehicles-select');
     clearTreeMultiSelect(select);
     if (holdingId.length > 0) {
        setTreeMultiSelect(this, 'select.vehicles-select', {'type': 'transfer', 'holding_id': holdingId});
     }
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).off('click', '[data-batch-transfer-save-modal]').on('click', '[data-batch-transfer-save-modal]', function () {
        _modal.submit(this, 'batch-transfer-save-modal', function(results) {
         _modal.hide('#user-batch-transfer-modal');
        });
    });

    // セレクトの値をセットする
    function setTreeMultiSelect(elm, find, datas = {}, callback = null) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('action');
            _ajax.post(action, datas, function (results) {
                clearTreeMultiSelect(select);
                $.each(results.options, function(index, option) {
                    if(option.id == ''){ return true; }
                    $(select).append($('<option></option>', {
                        'value': option.id,
                        'data-section': option.company_name + '|' + option.section_name
                    }).text(option.text));
                });
                vehicle_treemultiselect[0][0].reload();
                $('div.tree-multiselect .search').attr('placeholder', $(select).data('search'));
                if (callback != null) {
                    callback(elm);
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }

    // セレクトの値をクリアする
    function clearTreeMultiSelect(select) {
        $(select).empty();
        vehicle_treemultiselect[0][0].remove();
        vehicle_treemultiselect[0][0].reload();
        $('div.tree-multiselect .search').attr('placeholder', $(select).data('search'));
    }
}
